import create from 'zustand';

import { CountryStore } from './types';
import { createCountryActions } from './actions';
export const useCountryStore = create<CountryStore>()((set) => ({
  countries: [],
  ...createCountryActions(set),
}));
